export const PASSCODE_SUBMIT = 'PASSCODE_SUBMIT';
export const RESEND_CODE = 'RESEND_CODE';
export const UPDATE_RESEND_CODE_TIMER = 'app/VerifyPasscode/UPDATE_RESEND_CODE_TIMER';
export const RESET_SUCCESS_STATE ='app/VerifyPasscode/RESET_SUCCESS_STATE';
export const RESEND_COUNTER_TIME = 60;
export const RESEND_PASSWORD_RECOVERY_CODE = 'RESEND_PASSWORD_RECOVERY_CODE';
export const RECOVERY_PASSCODE_SUBMIT = 'RECOVERY_PASSCODE_SUBMIT';